// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"b9ddba08","369":"46680077","699":"f1fe969d"}[chunkId] + ".chunk.js";
};